import store from "./store";
import TranslatedObject from "../../shared-src/data/TranslatedObject";
/**
 * Les données d'une page de date
 */
export default class PageDateModel {
    constructor(json) {
        this.json=json;
        this.id=          json.id;
        this.date=        json.date;

        this.title=       json.title;
        /**
         *
         * @type {TranslatedObject}
         */
        this.titleTrad=       new TranslatedObject(json.title);
        /**
         *
         * @type {TranslatedObject}
         */
        this.text=        json.text;
        /**
         *
         * @type {TranslatedObject}
         */
        this.textTrad=   new TranslatedObject(json.text);
        this.img=         json.img;
        this.legende=     json.legende;
        /**
         *
         * @type {TranslatedObject}
         */
        this.legendeTrad=       new TranslatedObject(json.legende);
        this.imgSrc=      "les-images/"+this.img;
    }

    url(lang){
        if(!lang){
            lang=store.state.language;
        }
        return `/${lang}/date/${this.id}`;
    }

    /**
     *
     * @return {PageDateModel|null}
     */
    next(){
        let found=false;
        for(let p of PageDateModel.all()){
            if(found){
                return p;
            }
            if(p === this){
                found=true;
            }
        }
        return null;
    }

    /**
     *
     * @return {null|PageDateModel}
     */
    prev(){
        let found=false;
        let reversed = [].concat(PageDateModel.all()).reverse();
        for(let p of reversed){
            if(found){
                return p;
            }
            if(p === this){
                found=true;
            }
        }
        return null;
    }

    static boot(){
        if(!PageDateModel._all.length){
            let pagesJson=require("../public/pages.json");
            for(let p of pagesJson){
                PageDateModel._all.push(new PageDateModel(p));
            }
        }
    }

    /**
     * Renvoie toutes les pages date
     * @return {PageDateModel[]}
     */
    static all(){
        PageDateModel.boot();
        return PageDateModel._all;
    }

    /**
     * Renvoie la première page date
     * @return {PageDateModel}
     */
    static first(){
        PageDateModel.boot();
        return PageDateModel._all[0];
    }

}
/**
 *
 * @type {PageDateModel[]}
 * @private
 */
PageDateModel._all=[];
